import type { components } from "@entities/journal";

export const getDefaultValue = (data?: {
  mainJournal?: components["schemas"]["MainJournalViewResponseDto"];
}) => {
  return {
    journalnumber: data?.mainJournal?.titleJournal?.mainJournalNumber || "",
    projectCharacteristics:
      data?.mainJournal?.titleJournal?.projectCharacteristics || "",
    constructionStartDate:
      data?.mainJournal?.titleJournal?.constructionStartDate || "",
    constructionEndDate:
      data?.mainJournal?.titleJournal?.constructionEndDate || "",
    mainJournalStartDate:
      data?.mainJournal?.titleJournal?.mainJournalStartDate || "",
    mainJournalEndDate:
      data?.mainJournal?.titleJournal?.mainJournalEndDate || "",
  };
};

